<template>
  <div v-if="canAccessAdvancedSettings !== false">
    <v-row justify="center">
      <v-col cols="12" md="8" lg="12">
        <v-card class="elevation-2 rounded-lg my-5">
          <v-card-title class="py-4 primary--text text-center">
            <v-icon left color="primary">mdi-alert</v-icon>
            Equipamiento
          </v-card-title>
          <v-divider></v-divider>
          <v-alert
            v-if="loadError"
            type="error"
            outlined
            class="ma-4 mb-0"
            dismissible
            @input="loadError = null"
          >
            {{ loadError }}
          </v-alert>
          <v-card-text class="pa-4">
            <v-card class="alert-timeline-card mb-4" outlined>
              <v-row>
                <v-col cols="12">
                  <!-- Tabs principales -->
                  <v-tabs
                    v-model="viewModeVehiculoEquip"
                    background-color="white"
                    color="primary"
                    :show-arrows="$vuetify.breakpoint.smAndDown"
                    slider-color="primary"
                    :dense="$vuetify.breakpoint.smAndDown"
                    centered
                    grow
                    @change="onMainTabChange"
                  >
                    <v-tab v-if="DEALER_HAS_TYPE('vn') && HAS_PERMISSION('vn')">
                      <v-icon :left="$vuetify.breakpoint.mdAndUp" class="mb-1 mb-md-0">mdi-palette</v-icon>
                      <span class="ml-0 ml-md-1">{{ $vuetify.breakpoint.smAndDown ? '' : 'Vehiculo Nuevo' }}</span>
                    </v-tab>
                    <v-tab v-if="DEALER_HAS_TYPE('vo') && HAS_PERMISSION('vo')">
                      <v-icon :left="$vuetify.breakpoint.mdAndUp" class="mb-1 mb-md-0">mdi-shield-lock</v-icon>
                      <span class="ml-0 ml-md-1">{{ $vuetify.breakpoint.smAndDown ? '' : 'Vehiculo Usado' }}</span>
                    </v-tab>
                    <v-tab v-if="DEALER_HAS_TYPE('taller') && HAS_PERMISSION('taller')">
                      <v-icon :left="$vuetify.breakpoint.mdAndUp" class="mb-1 mb-md-0">mdi-tools</v-icon>
                      <span class="ml-0 ml-md-1">{{ $vuetify.breakpoint.smAndDown ? '' : 'Taller' }}</span>
                    </v-tab>
                  </v-tabs>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <!-- Tabs secundarios para Vehículo Nuevo -->
                  <v-tabs
                    v-if="currentMainTab === 'vehiculo_nuevo'"
                    v-model="viewModeVehiculoEquipFirstRecep"
                    background-color="white"
                    color="primary"
                    centered
                    fixed-tabs
                    :show-arrows="$vuetify.breakpoint.smAndDown"
                    slider-color="primary"
                    :dense="$vuetify.breakpoint.smAndDown"
                    @change="onNuevoSubTabChange"
                  >
                    <v-tab>
                      <v-icon :left="$vuetify.breakpoint.mdAndUp" class="mb-1 mb-md-0">mdi-account</v-icon>
                      <span class="ml-0 ml-md-1">1ra Recepción</span>
                    </v-tab>
                    <v-tab>
                      <v-icon :left="$vuetify.breakpoint.mdAndUp" class="mb-1 mb-md-0">mdi-view-grid-outline</v-icon>
                      <span class="ml-0 ml-md-1">Movimiento</span>
                    </v-tab>
                  </v-tabs>
                  
                  <!-- Tabs secundarios para Vehículo Usado -->
                  <v-tabs
                    v-else-if="currentMainTab === 'vehiculo_usado'"
                    v-model="viewModeVehiculoEquipUsado"
                    background-color="white"
                    color="primary"
                    centered
                    fixed-tabs
                    :show-arrows="$vuetify.breakpoint.smAndDown"
                    slider-color="primary"
                    :dense="$vuetify.breakpoint.smAndDown"
                    @change="onUsadoSubTabChange"
                  >
                    <v-tab>
                      <v-icon :left="$vuetify.breakpoint.mdAndUp" class="mb-1 mb-md-0">mdi-account</v-icon>
                      <span class="ml-0 ml-md-1">1ra Recepción</span>
                    </v-tab>
                    <v-tab>
                      <v-icon :left="$vuetify.breakpoint.mdAndUp" class="mb-1 mb-md-0">mdi-view-grid-outline</v-icon>
                      <span class="ml-0 ml-md-1">Movimiento</span>
                    </v-tab>
                  </v-tabs>
                  
                  <!-- Tabs secundarios para Taller -->
                  <v-tabs
                    v-else-if="currentMainTab === 'taller'"
                    v-model="viewModeVehiculoEquipTaller"
                    background-color="white"
                    color="primary"
                    centered
                    fixed-tabs
                    :show-arrows="$vuetify.breakpoint.smAndDown"
                    slider-color="primary"
                    :dense="$vuetify.breakpoint.smAndDown"
                    @change="onTallerSubTabChange"
                  >
                    <v-tab>
                      <v-icon :left="$vuetify.breakpoint.mdAndUp" class="mb-1 mb-md-0">mdi-account</v-icon>
                      <span class="ml-0 ml-md-1">1ra Recepción</span>
                    </v-tab>
                    <v-tab>
                      <v-icon :left="$vuetify.breakpoint.mdAndUp" class="mb-1 mb-md-0">mdi-view-grid-outline</v-icon>
                      <span class="ml-0 ml-md-1">Movimiento</span>
                    </v-tab>
                  </v-tabs>
                </v-col>
              </v-row>
              
              <!-- Contenido de los tabs -->
              <v-row>
                <v-col cols="12">
                  <!-- Vehículo Nuevo - Primera Recepción -->
                  <div v-if="currentMainTab === 'vehiculo_nuevo' && currentNuevoSubTab === 'primera_recepcion'">
                    <gasolina-diesel-hibrido
                      :key="`nuevo_primera_recepcion_gasolina`"
                      :fields="getEquipments('nuevo', 'primera_recepcion', 'gasolina_diesel_hibrido')"
                      :userState="{ list: userList, loading: isLoading, search2: '' }"
                      :loading="isLoading"
                      :saving="isLoading"
                      :validationsNoti="{ isValid: true, responsibleMov: [] }"
                      :errorsNoti="{ responsableMov: [] }"
                      :selectedResponsableMov="[]"
                      @update:fields="updateFields('nuevo', 'primera_recepcion', 'gasolina_diesel_hibrido', $event)"
                      @save-config="onSaveConfig('nuevo', 'primera_recepcion', 'gasolina_diesel_hibrido')"
                    />
                    <hibrido-enchufable
                      :key="`nuevo_primera_recepcion_hibrido`"
                      :fields="getEquipments('nuevo', 'primera_recepcion', 'hibrido_enchufable')"
                      :userState="{ list: userList, loading: isLoading, search2: '' }"
                      :loading="isLoading"
                      :saving="isLoading"
                      :validationsNoti="{ isValid: true, responsibleMov: [] }"
                      :errorsNoti="{ responsableMov: [] }"
                      :selectedResponsableMov="[]"
                      @update:fields="updateFields('nuevo', 'primera_recepcion', 'hibrido_enchufable', $event)"
                      @save-config="onSaveConfig('nuevo', 'primera_recepcion', 'hibrido_enchufable')"
                    />
                    <electrico
                      :key="`nuevo_primera_recepcion_electrico`"
                      :fields="getEquipments('nuevo', 'primera_recepcion', 'electrico')"
                      :userState="{ list: userList, loading: isLoading, search2: '' }"
                      :loading="isLoading"
                      :saving="isLoading"
                      :validationsNoti="{ isValid: true, responsibleMov: [] }"
                      :errorsNoti="{ responsableMov: [] }"
                      :selectedResponsableMov="[]"
                      @update:fields="updateFields('nuevo', 'primera_recepcion', 'electrico', $event)"
                      @save-config="onSaveConfig('nuevo', 'primera_recepcion', 'electrico')"
                    />
                  </div>
                  
                  <!-- Vehículo Nuevo - Movimiento -->
                  <div v-else-if="currentMainTab === 'vehiculo_nuevo' && currentNuevoSubTab === 'movimiento'">
                    <gasolina-diesel-hibrido
                      :key="`nuevo_movimiento_gasolina`"
                      :fields="getEquipments('nuevo', 'movimiento', 'gasolina_diesel_hibrido')"
                      :userState="{ list: userList, loading: isLoading, search2: '' }"
                      :loading="isLoading"
                      :saving="isLoading"
                      :validationsNoti="{ isValid: true, responsibleMov: [] }"
                      :errorsNoti="{ responsableMov: [] }"
                      :selectedResponsableMov="[]"
                      @update:fields="updateFields('nuevo', 'movimiento', 'gasolina_diesel_hibrido', $event)"
                      @save-config="onSaveConfig('nuevo', 'movimiento', 'gasolina_diesel_hibrido')"
                    />
                    <hibrido-enchufable
                      :key="`nuevo_movimiento_hibrido`"
                      :fields="getEquipments('nuevo', 'movimiento', 'hibrido_enchufable')"
                      :userState="{ list: userList, loading: isLoading, search2: '' }"
                      :loading="isLoading"
                      :saving="isLoading"
                      :validationsNoti="{ isValid: true, responsibleMov: [] }"
                      :errorsNoti="{ responsableMov: [] }"
                      :selectedResponsableMov="[]"
                      @update:fields="updateFields('nuevo', 'movimiento', 'hibrido_enchufable', $event)"
                      @save-config="onSaveConfig('nuevo', 'movimiento', 'hibrido_enchufable')"
                    />
                    <electrico
                      :key="`nuevo_movimiento_electrico`"
                      :fields="getEquipments('nuevo', 'movimiento', 'electrico')"
                      :userState="{ list: userList, loading: isLoading, search2: '' }"
                      :loading="isLoading"
                      :saving="isLoading"
                      :validationsNoti="{ isValid: true, responsibleMov: [] }"
                      :errorsNoti="{ responsableMov: [] }"
                      :selectedResponsableMov="[]"
                      @update:fields="updateFields('nuevo', 'movimiento', 'electrico', $event)"
                      @save-config="onSaveConfig('nuevo', 'movimiento', 'electrico')"
                    />
                  </div>
                  
                  <!-- Vehículo Usado - Primera Recepción -->
                  <div v-else-if="currentMainTab === 'vehiculo_usado' && currentUsadoSubTab === 'primera_recepcion'">
                    <gasolina-diesel-hibrido
                      :key="`usado_primera_recepcion_gasolina`"
                      :fields="getEquipments('usado', 'primera_recepcion', 'gasolina_diesel_hibrido')"
                      :userState="{ list: userList, loading: isLoading, search2: '' }"
                      :loading="isLoading"
                      :saving="isLoading"
                      :validationsNoti="{ isValid: true, responsibleMov: [] }"
                      :errorsNoti="{ responsableMov: [] }"
                      :selectedResponsableMov="[]"
                      @update:fields="updateFields('usado', 'primera_recepcion', 'gasolina_diesel_hibrido', $event)"
                      @save-config="onSaveConfig('usado', 'primera_recepcion', 'gasolina_diesel_hibrido')"
                    />
                    <hibrido-enchufable
                      :key="`usado_primera_recepcion_hibrido`"
                      :fields="getEquipments('usado', 'primera_recepcion', 'hibrido_enchufable')"
                      :userState="{ list: userList, loading: isLoading, search2: '' }"
                      :loading="isLoading"
                      :saving="isLoading"
                      :validationsNoti="{ isValid: true, responsibleMov: [] }"
                      :errorsNoti="{ responsableMov: [] }"
                      :selectedResponsableMov="[]"
                      @update:fields="updateFields('usado', 'primera_recepcion', 'hibrido_enchufable', $event)"
                      @save-config="onSaveConfig('usado', 'primera_recepcion', 'hibrido_enchufable')"
                    />
                    <electrico
                      :key="`usado_primera_recepcion_electrico`"
                      :fields="getEquipments('usado', 'primera_recepcion', 'electrico')"
                      :userState="{ list: userList, loading: isLoading, search2: '' }"
                      :loading="isLoading"
                      :saving="isLoading"
                      :validationsNoti="{ isValid: true, responsibleMov: [] }"
                      :errorsNoti="{ responsableMov: [] }"
                      :selectedResponsableMov="[]"
                      @update:fields="updateFields('usado', 'primera_recepcion', 'electrico', $event)"
                      @save-config="onSaveConfig('usado', 'primera_recepcion', 'electrico')"
                    />
                  </div>
                  
                  <!-- Vehículo Usado - Movimiento -->
                  <div v-else-if="currentMainTab === 'vehiculo_usado' && currentUsadoSubTab === 'movimiento'">
                    <gasolina-diesel-hibrido
                      :key="`usado_movimiento_gasolina`"
                      :fields="getEquipments('usado', 'movimiento', 'gasolina_diesel_hibrido')"
                      :userState="{ list: userList, loading: isLoading, search2: '' }"
                      :loading="isLoading"
                      :saving="isLoading"
                      :validationsNoti="{ isValid: true, responsibleMov: [] }"
                      :errorsNoti="{ responsableMov: [] }"
                      :selectedResponsableMov="getSelectedResponsable('usado', 'movimiento', 'gasolina_diesel_hibrido')"
                      @update:selectedResponsableMov="setSelectedResponsable('usado', 'movimiento', 'gasolina_diesel_hibrido', $event)"
                      @update:fields="updateFields('usado', 'movimiento', 'gasolina_diesel_hibrido', $event)"
                      @save-config="onSaveConfig('usado', 'movimiento', 'gasolina_diesel_hibrido')"
                    />
                    <hibrido-enchufable
                      :key="`usado_movimiento_hibrido`"
                      :fields="getEquipments('usado', 'movimiento', 'hibrido_enchufable')"
                      :userState="{ list: userList, loading: isLoading, search2: '' }"
                      :loading="isLoading"
                      :saving="isLoading"
                      :validationsNoti="{ isValid: true, responsibleMov: [] }"
                      :errorsNoti="{ responsableMov: [] }"
                      :selectedResponsableMov="[]"
                      @update:fields="updateFields('usado', 'movimiento', 'hibrido_enchufable', $event)"
                      @save-config="onSaveConfig('usado', 'movimiento', 'hibrido_enchufable')"
                    />
                    <electrico
                      :key="`usado_movimiento_electrico`"
                      :fields="getEquipments('usado', 'movimiento', 'electrico')"
                      :userState="{ list: userList, loading: isLoading, search2: '' }"
                      :loading="isLoading"
                      :saving="isLoading"
                      :validationsNoti="{ isValid: true, responsibleMov: [] }"
                      :errorsNoti="{ responsableMov: [] }"
                      :selectedResponsableMov="[]"
                      @update:fields="updateFields('usado', 'movimiento', 'electrico', $event)"
                      @save-config="onSaveConfig('usado', 'movimiento', 'electrico')"
                    />
                  </div>
                  
                  <!-- Taller - Primera Recepción -->
                  <div v-else-if="currentMainTab === 'taller' && currentTallerSubTab === 'primera_recepcion'">
                    <gasolina-diesel-hibrido
                      :key="`taller_primera_recepcion_gasolina`"
                      :fields="getEquipments('taller', 'primera_recepcion', 'gasolina_diesel_hibrido')"
                      :userState="{ list: userList, loading: isLoading, search2: '' }"
                      :loading="isLoading"
                      :saving="isLoading"
                      :validationsNoti="{ isValid: true, responsibleMov: [] }"
                      :errorsNoti="{ responsableMov: [] }"
                      :selectedResponsableMov="[]"
                      @update:fields="updateFields('taller', 'primera_recepcion', 'gasolina_diesel_hibrido', $event)"
                      @save-config="onSaveConfig('taller', 'primera_recepcion', 'gasolina_diesel_hibrido')"
                    />
                    <hibrido-enchufable
                      :key="`taller_primera_recepcion_hibrido`"
                      :fields="getEquipments('taller', 'primera_recepcion', 'hibrido_enchufable')"
                      :userState="{ list: userList, loading: isLoading, search2: '' }"
                      :loading="isLoading"
                      :saving="isLoading"
                      :validationsNoti="{ isValid: true, responsibleMov: [] }"
                      :errorsNoti="{ responsableMov: [] }"
                      :selectedResponsableMov="[]"
                      @update:fields="updateFields('taller', 'primera_recepcion', 'hibrido_enchufable', $event)"
                      @save-config="onSaveConfig('taller', 'primera_recepcion', 'hibrido_enchufable')"
                    />
                    <electrico
                      :key="`taller_primera_recepcion_electrico`"
                      :fields="getEquipments('taller', 'primera_recepcion', 'electrico')"
                      :userState="{ list: userList, loading: isLoading, search2: '' }"
                      :loading="isLoading"
                      :saving="isLoading"
                      :validationsNoti="{ isValid: true, responsibleMov: [] }"
                      :errorsNoti="{ responsableMov: [] }"
                      :selectedResponsableMov="[]"
                      @update:fields="updateFields('taller', 'primera_recepcion', 'electrico', $event)"
                      @save-config="onSaveConfig('taller', 'primera_recepcion', 'electrico')"
                    />
                  </div>
                  
                  <!-- Taller - Movimiento -->
                  <div v-else-if="currentMainTab === 'taller' && currentTallerSubTab === 'movimiento'">
                    <gasolina-diesel-hibrido
                      :key="`taller_movimiento_gasolina`"
                      :fields="getEquipments('taller', 'movimiento', 'gasolina_diesel_hibrido')"
                      :userState="{ list: userList, loading: isLoading, search2: '' }"
                      :loading="isLoading"
                      :saving="isLoading"
                      :validationsNoti="{ isValid: true, responsibleMov: [] }"
                      :errorsNoti="{ responsableMov: [] }"
                      :selectedResponsableMov="getSelectedResponsable('taller', 'movimiento', 'gasolina_diesel_hibrido')"
                      @update:selectedResponsableMov="setSelectedResponsable('taller', 'movimiento', 'gasolina_diesel_hibrido', $event)"
                      @update:fields="updateFields('taller', 'movimiento', 'gasolina_diesel_hibrido', $event)"
                      @save-config="onSaveConfig('taller', 'movimiento', 'gasolina_diesel_hibrido')"
                    />
                    <hibrido-enchufable
                      :key="`taller_movimiento_hibrido`"
                      :fields="getEquipments('taller', 'movimiento', 'hibrido_enchufable')"
                      :userState="{ list: userList, loading: isLoading, search2: '' }"
                      :loading="isLoading"
                      :saving="isLoading"
                      :validationsNoti="{ isValid: true, responsibleMov: [] }"
                      :errorsNoti="{ responsableMov: [] }"
                      :selectedResponsableMov="[]"
                      @update:fields="updateFields('taller', 'movimiento', 'hibrido_enchufable', $event)"
                      @save-config="onSaveConfig('taller', 'movimiento', 'hibrido_enchufable')"
                    />
                    <electrico
                      :key="`taller_movimiento_electrico`"
                      :fields="getEquipments('taller', 'movimiento', 'electrico')"
                      :userState="{ list: userList, loading: isLoading, search2: '' }"
                      :loading="isLoading"
                      :saving="isLoading"
                      :validationsNoti="{ isValid: true, responsibleMov: [] }"
                      :errorsNoti="{ responsableMov: [] }"
                      :selectedResponsableMov="[]"
                      @update:fields="updateFields('taller', 'movimiento', 'electrico', $event)"
                      @save-config="onSaveConfig('taller', 'movimiento', 'electrico')"
                    />
                  </div>

                  <!-- Estado de carga -->
                  <div v-else-if="isLoading" class="text-center pa-4">
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                    <div class="mt-2">Cargando configuración...</div>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import EquipmentService from '@/services/EquipmentService'
import GasolinaDieselHibrido from './GasolinaDieselHibrido.vue'
import HibridoEnchufable from './HibridoEnchufable.vue'
import Electrico from './Electrico.vue'
import UserService from '@/services/UserService'
import PartnerGroupService from '@/services/PartnerGroupService'

export default {
  name: 'EquipmentSettings',
  components: {
    'gasolina-diesel-hibrido': GasolinaDieselHibrido,
    'hibrido-enchufable': HibridoEnchufable,
    'electrico': Electrico
  },
  data() {
    return {
      isLoading: false,
      loadError: null,
      // Usar índices numéricos para los v-model de Vuetify
      viewModeVehiculoEquip: 0, // 0 = vehiculo_nuevo, 1 = vehiculo_usado, 2 = taller
      viewModeVehiculoEquipFirstRecep: 0, // 0 = primera_recepcion, 1 = movimiento
      viewModeVehiculoEquipUsado: 0, // 0 = primera_recepcion, 1 = movimiento
      viewModeVehiculoEquipTaller: 0, // 0 = primera_recepcion, 1 = movimiento
      equipmentsByKey: {},
      selectedResponsables: {},
      userList: [],
      canAccessAdvancedSettings: true
    }
  },
  props: {
    // Optional parent userState object passed from Settings.vue
    userState: {
      type: Object,
      default: () => ({ list: [], loading: false })
    }
  },
  computed: {
    ...mapGetters(['DEALER_HAS_TYPE', 'HAS_PERMISSION']),
    
    // Lista de tabs visibles en orden
    visibleTabs() {
      const tabs = []
      if (this.DEALER_HAS_TYPE('vn') && this.HAS_PERMISSION('vn')) {
        tabs.push('vehiculo_nuevo')
      }
      if (this.DEALER_HAS_TYPE('vo') && this.HAS_PERMISSION('vo')) {
        tabs.push('vehiculo_usado')
      }
      if (this.DEALER_HAS_TYPE('taller') && this.HAS_PERMISSION('taller')) {
        tabs.push('taller')
      }
      return tabs
    },
    
    // Computed properties para obtener los valores string reales
    currentMainTab() {
      return this.visibleTabs[this.viewModeVehiculoEquip] || this.visibleTabs[0] || 'vehiculo_nuevo'
    },
    currentNuevoSubTab() {
      return this.viewModeVehiculoEquipFirstRecep === 0 ? 'primera_recepcion' : 'movimiento'
    },
    currentUsadoSubTab() {
      return this.viewModeVehiculoEquipUsado === 0 ? 'primera_recepcion' : 'movimiento'
    },
    currentTallerSubTab() {
      return this.viewModeVehiculoEquipTaller === 0 ? 'primera_recepcion' : 'movimiento'
    }
  },
  methods: {
    // Métodos para manejar cambios de tabs
    onMainTabChange(newValue) {
      // Obtener la condición basada en el índice del tab visible
      const condition = this.visibleTabs[newValue] || 'vehiculo_nuevo'
      const conditionMap = {
        'vehiculo_nuevo': 'nuevo',
        'vehiculo_usado': 'usado',
        'taller': 'taller'
      }
      
      const mappedCondition = conditionMap[condition]
      const stage = 'primera_recepcion' // Reset al cambiar tab principal
      
      // Reset subtabs
      this.viewModeVehiculoEquipFirstRecep = 0
      this.viewModeVehiculoEquipUsado = 0
      this.viewModeVehiculoEquipTaller = 0
      
      this.loadAllSubTypes(mappedCondition, stage)
    },
    
    onNuevoSubTabChange(newValue) {
      const stage = newValue === 0 ? 'primera_recepcion' : 'movimiento'
      this.loadAllSubTypes('nuevo', stage)
    },
    
    onUsadoSubTabChange(newValue) {
      const stage = newValue === 0 ? 'primera_recepcion' : 'movimiento'
      this.loadAllSubTypes('usado', stage)
    },
    
    onTallerSubTabChange(newValue) {
      const stage = newValue === 0 ? 'primera_recepcion' : 'movimiento'
      this.loadAllSubTypes('taller', stage)
    },
    
    async loadDealerUsers() {
      this.isLoading = true
      try {
        const isPartner = this.$store.getters.IS_PARTNER
        let allUsers = []

        if (isPartner) {
          const groupsResponse = await PartnerGroupService.index({ expand: 'dealerships' })
          const groups = groupsResponse.data.data || groupsResponse.data || []
          const groupsArray = Array.isArray(groups) ? groups : (groups.data || [])

          const currentDealerId = this.$store.getters.CURRENT_USER?.dealer?.id
          const myGroups = groupsArray.filter(group =>
            (group.dealerships || []).some(d => d.id === currentDealerId)
          )

          const dealerIdsSeen = new Set()
          const dealerships = []
          for (const group of myGroups) {
            for (const d of (group.dealerships || [])) {
              if (!dealerIdsSeen.has(d.id)) {
                dealerships.push(d)
                dealerIdsSeen.add(d.id)
              }
            }
          }

          for (const dealer of dealerships) {
            try {
              const [usersResponse, managersResponse] = await Promise.all([
                UserService.getOnlyUsers({ 'filter[dealerId]': dealer.id, 'per-page': 200 }),
                UserService.getDealerManager(dealer.id)
              ])

              const dealerUsers = usersResponse.data.data || usersResponse.data || []
              const dealerManagers = managersResponse.data?.data?.data || []

              const existingIds = new Set(allUsers.map(u => u.id))
              dealerUsers.forEach(u => { if (!existingIds.has(u.id)) { allUsers.push({ ...u, _dealerName: dealer.name }); existingIds.add(u.id) } })
              dealerManagers.forEach(m => { if (m && !existingIds.has(m.id)) { allUsers.push({ ...m, _dealerName: dealer.name }); existingIds.add(m.id) } })
            } catch (dealerError) {
              console.error(`Error cargando usuarios del dealer ${dealer.name}:`, dealerError)
            }
          }
        } else {
          const [response, managerResp] = await Promise.all([
            UserService.get({ 'per-page': 200 }),
            UserService.getMyManager()
          ])

          allUsers = response.data.data || []

          if (managerResp && managerResp.data && managerResp.data.data) {
            const mgrData = managerResp.data.data
            const mgrs = Array.isArray(mgrData) ? mgrData : [mgrData]
            mgrs.forEach(m => {
              if (m && !allUsers.some(u => u.id === m.id)) allUsers.unshift(m)
            })
          }
        }

        this.userList = allUsers

        if (this.userState && typeof this.userState === 'object') {
          this.userState.list = allUsers
          this.userState.loading = false
        }
      } catch (e) {
        console.error('Error loading users:', e)
        this.userList = []
      } finally {
        this.isLoading = false
      }
    },
    
    getSelectedResponsable(condition, stage, type) {
      const key = `${condition}_${stage}_${type}`
      return this.selectedResponsables[key] || []
    },
    
    setSelectedResponsable(condition, stage, type, value) {
      const key = `${condition}_${stage}_${type}`
      this.$set(this.selectedResponsables, key, value)
    },
    
    async loadEquipmentsForSubType(condition, stage, type) {
      const key = `${condition}_${stage}_${type}`
      
      // Si ya tenemos los datos, no hacer la petición nuevamente
      if (this.equipmentsByKey[key]) {
        return
      }
      
      this.isLoading = true
      this.loadError = null
      
      try {
        const response = await EquipmentService.getConfigByCombination(condition, stage, type)
        
        if (response.data?.data?.success && response.data.data.data?.equipments) {
          const equipments = response.data.data.data.equipments
          const equipmentsList = []
          
          // Filtrar equipamientos que están asignados al tipo de vehículo actual
          if (Array.isArray(equipments)) {
            equipments.forEach(equipment => {
              const isAssignedToVehicleType = equipment.vehicle_types && 
                equipment.vehicle_types.some(vt => vt.type === type)
              
              if (isAssignedToVehicleType) {
                // Usar los datos directamente de la API sin mapeos
                equipmentsList.push({
                  id: equipment.id,
                  name: equipment.name,
                  is_active: equipment.is_active || false,
                  is_configured: equipment.is_configured || false,
                  responsibles: Array.isArray(equipment.responsibles) ? equipment.responsibles : [],
                  vehicle_types: equipment.vehicle_types || []
                })
              }
            })
          }
          
          this.$set(this.equipmentsByKey, key, equipmentsList)
        } else {
          console.warn('[API] No equipment data found in response')
          this.$set(this.equipmentsByKey, key, [])
        }
      } catch (e) {
        console.error('[API exception]', e)
        this.loadError = 'Error al cargar la configuración.'
        this.$set(this.equipmentsByKey, key, [])
      } finally {
        this.isLoading = false
      }
    },
    
    async onSaveConfig(vehicleCondition, receptionStage, vehicleType) {
      const fieldsObject = this.getEquipments(vehicleCondition, receptionStage, vehicleType)
      const equipments = []
      
      // Convert object format back to array format for API
      Object.values(fieldsObject).forEach(equipment => {
        equipments.push({
          id: equipment.id,
          name: equipment.name,
          is_active: !!equipment.is_active,
          responsibles: Array.isArray(equipment.responsibles)
            ? equipment.responsibles.map(r => typeof r === 'object' ? r.id : r)
            : []
        })
      })
      
      const payload = {
        vehicle_condition: vehicleCondition,
        reception_stage: receptionStage,
        vehicle_type: vehicleType,
        equipments
      }
      await this.saveConfigRelacional(payload)
    },
    
    async saveConfigRelacional(payload) {
      this.isLoading = true
      this.loadError = null
      try {
        const response = await EquipmentService.saveConfig(payload)
        if (!response.data.success) {
          this.loadError = response.data.message || 'Error al guardar.'
        } else {
          // Recargar los datos después de guardar
          this.loadEquipmentsForSubType(payload.vehicle_condition, payload.reception_stage, payload.vehicle_type)
        }
      } catch (e) {
        console.error('[saveConfigRelacional] Error:', e)
        this.loadError = 'Error al guardar la configuración.'
      } finally {
        this.isLoading = false
      }
    },
    
    loadAllSubTypes(condition, stage) {
      this.loadEquipmentsForSubType(condition, stage, 'gasolina_diesel_hibrido')
      this.loadEquipmentsForSubType(condition, stage, 'hibrido_enchufable')
      this.loadEquipmentsForSubType(condition, stage, 'electrico')
    },
    
    updateFields(condition, stage, type, updatedFields) {
      const key = `${condition}_${stage}_${type}`
      const equipmentsList = this.equipmentsByKey[key] || []
      
      // Field mappings (reverse lookup)
      const fieldMappings = {
        'equip_luz_v16': 'baliza_v16',
        'equip_chaleco_reflectante': 'chalecos',
        'equip_triangulo': 'triangulo',
        'equip_documentacion': 'documentacion',
        'equip_cable_carga': 'cable_carga'
      }
      
      // Update the equipmentsList with changes from child component
      const updatedList = equipmentsList.map(equipment => {
        // Check static mappings first
        const fieldName = Object.keys(fieldMappings).find(key => fieldMappings[key] === equipment.name)
        // If not found in static mappings, use dynamic field name
        const actualFieldName = fieldName || `equip_${equipment.name.toLowerCase().replace(/\s+/g, '_')}`
        
        if (updatedFields[actualFieldName]) {
          return {
            ...equipment,
            is_active: updatedFields[actualFieldName].is_active,
            responsibles: updatedFields[actualFieldName].responsibles || equipment.responsibles
          }
        }
        return equipment
      })
      
      this.$set(this.equipmentsByKey, key, updatedList)
    },
    
    getEquipments(condition, stage, type) {
      const key = `${condition}_${stage}_${type}`
      const equipmentsList = this.equipmentsByKey[key] || []
      
      // Transform array to object format expected by child components
      const fieldsObject = {}
      
      // Define field mappings for each equipment
      const fieldMappings = {
        'baliza_v16': 'equip_luz_v16',
        'chalecos': 'equip_chaleco_reflectante',
        'triangulo': 'equip_triangulo',
        'documentacion': 'equip_documentacion',
        'cable_carga': 'equip_cable_carga'
      }
      
      equipmentsList.forEach(equipment => {
        // Find the field name for this equipment
        const fieldName = fieldMappings[equipment.name] || `equip_${equipment.name.toLowerCase().replace(/\s+/g, '_')}`
        fieldsObject[fieldName] = {
          id: equipment.id,
          name: equipment.name,
          is_active: equipment.is_active,
          is_configured: equipment.is_configured,
          responsibles: equipment.responsibles || [],
          vehicle_types: equipment.vehicle_types || []
        }
      })
      
      return fieldsObject
    }
  },
  
  mounted() {
    // Cargar el primer tab disponible basado en los permisos del dealer
    const firstAvailableTab = this.visibleTabs[0]
    const conditionMap = {
      'vehiculo_nuevo': 'nuevo',
      'vehiculo_usado': 'usado',
      'taller': 'taller'
    }
    const condition = conditionMap[firstAvailableTab] || 'nuevo'
    
    this.loadAllSubTypes(condition, 'primera_recepcion')
    this.loadDealerUsers()
  }
}
</script>

<style scoped>
.alert-timeline-card {
  border-radius: 12px;
}
</style>
